import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { classProductSkeleton } from '../ProductCardSkeleton/ProductCardSkeleton';

export const ProductsCardsSkeletonWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${getPurpurSpacing('300')};
    justify-content: center;

    .${classProductSkeleton} + .${classProductSkeleton} {
        display: none;
    }

    ${purpurMedia('md')`
        grid-template-columns: repeat(auto-fill, minmax(19.875rem, 1fr));
        justify-content: flex-start;

        .${classProductSkeleton} + .${classProductSkeleton} {
            display: block;
        }
    `}
`;
